import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../../constants/tableConstants/API";

interface DealData {
  _id: null | string;
  title: string;
  description: string;
  routes: string;
  label_metadata: string;
  table_name: string;
  file_extenstion: string;
  columns: string[];
  is_active:boolean
}
interface DataIngestionAction {
  data: DealData[];
  columnsOfExcelSheet: any | string[];
  rowsOfExcelSheet: any;
  uploadedFileName: string;
  isLoading: boolean;
  error: null;
}
const initialState: DataIngestionAction = {
  data: [],
  columnsOfExcelSheet: "",
  rowsOfExcelSheet: [],
  uploadedFileName: "",
  isLoading: false,
  error: null,
};

export const DealSearchApi = createAsyncThunk(
  "search/deal",
  async (searchTerm: string, thunkAPI) => {
    console.log(searchTerm, "searchterm");
    try {
      const response = await axios.get(
        `${API.GETDEALSEARCHAPI}?search=${searchTerm}`,
        // `${API.GETDEALSEARCHAPI}/search=${searchTerm}`
      );
      console.log("Search results:", response.data);
      return response.data;
    } catch (err) {
     console.error("Search API failed:", err);
      return thunkAPI.rejectWithValue("Search API failed");  // return thunkAPI.rejectWithValue(err?.response?.data?.message);
    }
  }
);
export const DataIngestionSlice = createSlice({
  name: "DataIngestion",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(DealSearchApi.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(DealSearchApi.fulfilled, (state, action) => {
        state.data = action.payload;
        console.log(action.payload, "searchdealapi");
        state.isLoading = false;
      })
      .addCase(DealSearchApi.rejected, (state, action) => {
        state.isLoading = false;
        // state.error = action.payload || null;
      });
  },
});
export const {} = DataIngestionSlice.actions;
export default DataIngestionSlice.reducer;
